import Helpers from "utils/Global/Helpers";

/* eslint no-underscore-dangle: "off" */

export default {
  checkIfContactExists: ({ credentials, eventId, orgId, email }) =>
    new Promise((success, error) => {
      Helpers.request({
        method: "post",
        url: `${window.__LENND_API_BASE_URL__}/contacts${
          eventId ? `/event/${eventId}` : `/organization/${orgId}`
        }/contact-exists`,
        credentials,
        data: { email },
        success,
        error
      });
    })
};
